export default "__VITE_ASSET__d9e5d11b__"